import { TreeMultiDropDown } from '@components/TreeMultiDropDown';

const selectItems = {
  day: [
    { value: 'today', label: 'Today' },
    { value: 'yesterday', label: 'Yesterday' },
    { value: 'tomorrow', label: 'Tomorrow' },
  ],
  currentPeriod: [
    { value: 'this-week', label: 'This week' },
    { value: 'this-month', label: 'This month' },
    { value: 'this-quarter', label: 'This quarter' },
    { value: 'this-year', label: 'This year' },
  ],
  rollingPast: [
    { value: 'last-7-days', label: 'Last 7 days' },
    { value: 'last-14-days', label: 'Last 14 days' },
    { value: 'last-30-days', label: 'Last 30 days' },
    { value: 'last-90-days', label: 'Last 90 days' },
    { value: 'last-12-months', label: 'Last 12 months' },
  ],
  previousPeriod: [
    { value: 'last-week', label: 'Last week' },
    { value: 'last-month', label: 'Last month' },
    { value: 'last-quarter', label: 'Last quarter' },
    { value: 'last-year', label: 'Last year' },
  ],
  rollingFuture: [
    { value: 'next-7-days', label: 'Next 7 days' },
    { value: 'next-14-days', label: 'Next 14 days' },
    { value: 'next-30-days', label: 'Next 30 days' },
    { value: 'next-90-days', label: 'Next 90 days' },
    { value: 'next-12-months', label: 'Next 12 months' },
  ],
  nextPeriod: [
    { value: 'next-week', label: 'Next week' },
    { value: 'next-month', label: 'Next month' },
    { value: 'next-quarter', label: 'Next quarter' },
    { value: 'next-year', label: 'Next year' },
  ],
  openEnded: [
    { value: 'in-the-past', label: 'In the past' },
    { value: 'in-the-future', label: 'In the future' },
  ],
} as const;

const getGroupStringMapping = (group: keyof typeof selectItems) => {
  switch (group) {
    case 'day':
      return 'Day';
    case 'currentPeriod':
      return 'Current period';
    case 'rollingPast':
      return 'Rolling past';
    case 'previousPeriod':
      return 'Previous period';
    case 'rollingFuture':
      return 'Rolling future';
    case 'nextPeriod':
      return 'Next period';
    case 'openEnded':
      return 'Open ended';
  }
};

export function RelativeDateSelect({ value, onChange }: { value: string[]; onChange: (value: string[]) => void }) {
  return (
    <TreeMultiDropDown
      placeholder="Select a relative date"
      options={Object.entries(selectItems).map(([group, items]) => ({
        id: group,
        label: getGroupStringMapping(group as keyof typeof selectItems),
        children: items.map((item) => ({
          id: item.value,
          label: item.label,
          value: item.value,
        })),
      }))}
      value={value}
      onChange={(value) => {
        onChange(value || []);
      }}
    />
  );
}
